<template>
    <html>
    <body style="background: #fff" v-loading="loading">
        <!--主体开始-->
        <div class="nding">
            <div>
                <p>当前位置：</p>
                <a href="/home">首页</a>&gt; <a href="/purchase/list">供求广场</a>&gt; <a href="">求购详情</a>
            </div>
        </div>
        <section class="ncontainer2">
            <div class="neit">
                <h2>求购详情</h2>
                <div class="li1">
                    <h4>求购品类：{{model.categoryname}}{{!$util.isEmpty(model.attr_value_name) ? '(' + model.attr_value_name + ')' : ''}}</h4>
                    <div>
                        <ul>
                            <li>求购数量：{{model.numbername}}</li>
                            <li>求购时间：{{ $util.timeStampTurnTime(model.createtime, 'YYYY-MM-DD') }}</li>
                            <li>浏览数：{{model.click_count}}</li>
                        </ul>
                        <ul>
                            <li>期望货源地：{{model.areaname}}</li>
                            <li>收货地：{{model.address}}</li>
                            <li>备注：{{model.remark}}</li>
                        </ul>
                    </div>
                </div>
                <div class="li2">
                    <h4>求购商信息</h4>
                    <div>
                        <div>
                            <div class="tu"> <img :src="$util.img(member.headimg)" alt=""> </div>
                            <div class="y">
                                <p>发布人：{{member.nickname}}</p>
                                <p>身份：求购商</p>
                            </div>
                        </div>
                        <a href="#" id="ClickMe">去报价</a>
                    </div>
                </div>
            </div>
        </section>
        <!--报价弹出层-->
        <div id="goodcover"></div>
        <div id="code" style="height: 120px;width: 600px">
            <div class="close"><a href="javascript:void(0)" id="closebt"><img src="@/assets/styles/images/close.png" alt=""></a></div>
            <div class="fbbj">
                <h4>只有供应商才可以报价哦~</h4>
                <div class="fbbj_a">
                    <a href="http://shopsn.3nong.com/shop/login/login.html" target="_blank" style="color:#fff">立即点击  ></a>
                    <span>前往商家后台</span>
                </div>
            </div>
        </div>
    </body>
</html>
</template>

<script>
    import { purchaseDetail } from '@/api/purchase/purchase';

    export default {
        name: '',
        components: {},
        data: () => {
            return {
                loading: true,
                id: 0,
                model:{},
                member:{},
            };
        },
        created() {
            this.id = this.$route.query.id;
            this.getdetails();
        },

        methods: {
            getdetails() {
                purchaseDetail({
                    id: this.id
                }).then(res => {
                    if(res.code == 0) {
                        this.model = res.data;
                        this.member = res.data.member_info;
                        this.loading = false;
                    }
                }).catch(err => {
                    this.loading = false;
                    //this.$message.error(err.message);
                });
            },
        },

        mounted () {
            $(function() {
                //alert($(window).height());
                $('#ClickMe').click(function() {
                    $('#code').center();
                    $('#goodcover').show();
                    $('#code').fadeIn();
                });
                $('#closebt').click(function() {
                    $('#code').hide();
                    $('#goodcover').hide();
                });
                $('#goodcover').click(function() {
                    $('#code').hide();
                    $('#goodcover').hide();
                });
                jQuery.fn.center = function(loaded) {
                    var obj = this;
                    var body_width = parseInt($(window).width());
                    var body_height = parseInt($(window).height());
                    var block_width = parseInt(obj.width());
                    var block_height = parseInt(obj.height());

                    left_position = parseInt((body_width / 2) - (block_width / 2) + $(window).scrollLeft());
                    if (body_width < block_width) {
                        var left_position = 0 + $(window).scrollLeft();
                    };

                    top_position = parseInt((body_height / 2) - (block_height / 2) + $(window).scrollTop());
                    if (body_height < block_height) {
                        var top_position = 0 + $(window).scrollTop();
                    };

                    if (!loaded) {

                        obj.css({
                            'position': 'absolute'
                        });
                        obj.css({
                            'top': ($(window).height() - $('#code').height()) * 0.5,
                            'left': left_position
                        });
                        $(window).bind('resize', function() {
                            obj.center(!loaded);
                        });
                        $(window).bind('scroll', function() {
                            obj.center(!loaded);
                        });

                    } else {
                        obj.stop();
                        obj.css({
                            'position': 'absolute'
                        });
                        obj.animate({
                            'top': top_position
                        }, 200, 'linear');
                    }
                }

            })
        },

    }
</script>
